import script from "./IntegrationsView.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegrationsView.vue?vue&type=script&setup=true&lang=js"

import "./IntegrationsView.vue?vue&type=style&index=0&id=767cb73e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-767cb73e"]])

export default __exports__